var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader_container"},[_c('div',{staticClass:"loader_MA_left"}),_c('div',{staticClass:"loader_MA_Circle"}),_c('div',{staticClass:"loader_MA_rigth"})])
}]

export { render, staticRenderFns }